










































































import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { User, UserProfile } from "@/services/users/types";
import { Email } from "@/services/support/types";
import { sendEmail } from "@/services/support/supportService";
import { getUserProfile } from "@/services/users/usersService";

const authenticationModule = namespace("authentication");

@Component
export default class Support extends Vue {
    @Prop() private previousRoute!: string;
    @authenticationModule.Getter("getCurrentUser") currentUser!: User;

    email = {} as Email;
    emailSent = false;
    emailSendMode = false;
    userProfile = {} as UserProfile;

    created() {
        getUserProfile(this.currentUser.id).then(response => {
            this.userProfile = response;
            this.email.phoneNumber = this.userProfile.phoneNumber;
            this.emailSendMode = false;
        });
    }

    // footer buttons
    send(evt: any) {
        evt.preventDefault();
        this.email.adress = this.userProfile.email;
        this.email.firstName = this.userProfile.firstName;
        this.email.lastName = this.userProfile.lastName;
        this.email.lastPageVisited = this.previousRoute;
        sendEmail(this.email).then(response => {
            this.emailSent = response.emailSent;
            this.emailSendMode = true;
        });
    }

    // header buttons
    back() {
        window.history.go(-1);
    }
}
